module.exports = __webpack_public_path__ + "img/no_se_encontraron_resultados.cc9ededb.png";